<app-side-menu>
  <div class="ipva-licensing-container">
    <div class="row mb-3">
      <div class="col-12">
        <div class="page-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div>
            <button type="button" class="btn btn-link p-0 mb-2 text-muted" (click)="goBack()">
              <i class="fas fa-arrow-left me-1"></i> Voltar para Veículos
            </button>
            <h1 class="page-title">
              <i class="fas fa-file-invoice-dollar me-3"></i>
              IPVA e Licenciamento
            </h1>
            <p class="page-subtitle mb-0" *ngIf="vehicle">
              Veículo: {{ vehicle.plateNumber }} — {{ vehicle.brand }} {{ vehicle.model }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="card ipva-licensing-card" *ngIf="vehicleId">
      <div class="card-body">
        <div class="bank-provider-info mb-3" *ngIf="bankProvider">
          <span class="badge bg-secondary me-2">Provedor: {{ bankProvider.providerName }}</span>
          <span *ngIf="!bankProvider.isAvailable" class="text-muted small">
            Integração bancária não ativa. Use "Registrar pagamento manual" para lançar pagamentos.
          </span>
        </div>

        <div class="filters-section mb-3">
          <div class="d-flex flex-wrap gap-2 align-items-end">
            <div class="filter-group">
              <label class="form-label small mb-0">Tipo</label>
              <select class="form-select form-select-sm" [(ngModel)]="filterType" (change)="onFilterChange()">
                <option value="">Todos</option>
                <option value="IPVA">IPVA</option>
                <option value="Licenciamento">Licenciamento</option>
              </select>
            </div>
            <div class="filter-group">
              <label class="form-label small mb-0">Ano</label>
              <select class="form-select form-select-sm" [(ngModel)]="filterYear" (change)="onFilterChange()">
                <option [ngValue]="null">Todos</option>
                <option *ngFor="let y of currentYears" [ngValue]="y">{{ y }}</option>
              </select>
            </div>
            <div class="filter-actions ms-auto">
              <button type="button" class="btn btn-success btn-sm" (click)="openModalBank()" *ngIf="bankProvider?.isAvailable">
                <i class="fas fa-university me-1"></i> Pagar via banco
              </button>
              <button type="button" class="btn btn-primary btn-sm" (click)="openModalManual()">
                <i class="fas fa-edit me-1"></i> Registrar pagamento manual
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

<div *ngIf="!loading && getTableData().length > 0" class="table-content">
          <app-table
            [title]="tableTitle"
            [columns]="columns"
            [data]="getTableData()"
            [loading]="loading"
            [showSearch]="showSearch"
            [searchPlaceholder]="searchPlaceholder"
            [clickable]="clickable"
            [actions]="actions"
            [enableSorting]="true"
            [clientSideSort]="true"
            (rowClick)="onActionClick({ action: 'view', item: $event })"
            (actionClick)="onActionClick($event)">
          </app-table>
        </div>

        <div *ngIf="!loading && !error && getTableData().length === 0" class="empty-state">
          <i class="fas fa-file-invoice"></i>
          <h3>Nenhum registro de IPVA ou Licenciamento</h3>
          <p>Use "Pagar via banco" ou "Registrar pagamento manual" para adicionar.</p>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>

<!-- Modal Pagar via banco -->
<app-modal
  [isOpen]="showModalBank"
  title="Pagar via banco"
  size="md"
  (close)="closeModalBank()">
  <div *ngIf="bankSuccessMessage" class="alert alert-success">
    {{ bankSuccessMessage }}
    <a *ngIf="boletoUrl" [href]="boletoUrl" target="_blank" rel="noopener" class="alert-link ms-2">Abrir boleto</a>
  </div>
  <form *ngIf="!bankSuccessMessage" (ngSubmit)="submitBank()">
    <div class="mb-3">
      <label class="form-label">Tipo</label>
      <select class="form-select" [(ngModel)]="formBank.paymentType" name="paymentType">
        <option value="IPVA">IPVA</option>
        <option value="Licenciamento">Licenciamento</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Ano de referência</label>
      <select class="form-select" [(ngModel)]="formBank.referenceYear" name="referenceYear">
        <option *ngFor="let y of currentYears" [ngValue]="y">{{ y }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Valor (R$)</label>
      <input type="number" step="0.01" class="form-control" [(ngModel)]="formBank.amount" name="amount" required />
    </div>
    <div class="mb-3">
      <label class="form-label">Número do documento</label>
      <input type="text" class="form-control" [(ngModel)]="formBank.documentNumber" name="documentNumber" />
    </div>
    <div class="mb-3">
      <label class="form-label">Observações</label>
      <textarea class="form-control" [(ngModel)]="formBank.notes" name="notes" rows="2"></textarea>
    </div>
  </form>
  <div slot="footer" *ngIf="!bankSuccessMessage">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModalBank()">Fechar</button>
    <button type="button" class="btn btn-success ms-2" (click)="submitBank()" [disabled]="submittingBank">
      <span *ngIf="submittingBank" class="spinner-border spinner-border-sm me-1"></span>
      Solicitar pagamento
    </button>
  </div>
  <div slot="footer" *ngIf="bankSuccessMessage">
    <button type="button" class="btn btn-primary" (click)="closeModalBank()">Fechar</button>
  </div>
</app-modal>

<!-- Modal Registrar pagamento manual -->
<app-modal
  [isOpen]="showModalManual"
  title="Registrar pagamento manual"
  size="md"
  (close)="closeModalManual()">
  <form (ngSubmit)="submitManual()">
    <div class="mb-3">
      <label class="form-label">Tipo</label>
      <select class="form-select" [(ngModel)]="formManual.paymentType" name="paymentType">
        <option value="IPVA">IPVA</option>
        <option value="Licenciamento">Licenciamento</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Ano de referência</label>
      <select class="form-select" [(ngModel)]="formManual.referenceYear" name="referenceYear">
        <option *ngFor="let y of currentYears" [ngValue]="y">{{ y }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Valor (R$)</label>
      <input type="number" step="0.01" class="form-control" [(ngModel)]="formManual.amount" name="amount" required />
    </div>
    <div class="mb-3">
      <label class="form-label">Data do pagamento</label>
      <input type="date" class="form-control" [(ngModel)]="formManual.paymentDate" name="paymentDate" required />
    </div>
    <div class="mb-3">
      <label class="form-label">Número do documento / guia</label>
      <input type="text" class="form-control" [(ngModel)]="formManual.documentNumber" name="documentNumber" />
    </div>
    <div class="mb-3">
      <label class="form-label">Observações</label>
      <textarea class="form-control" [(ngModel)]="formManual.notes" name="notes" rows="2"></textarea>
    </div>
  </form>
  <div slot="footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModalManual()">Cancelar</button>
    <button type="button" class="btn btn-primary ms-2" (click)="submitManual()" [disabled]="submittingManual">
      <span *ngIf="submittingManual" class="spinner-border spinner-border-sm me-1"></span>
      Registrar
    </button>
  </div>
</app-modal>
